import { MapStyle } from './models/map.model';

export class MapVectorStyle {
  private stylesCache = {};

  constructor(private stylesData: MapStyle[], private partionColumNames: string[]) {}

  public findStyles(feature: any, resolution: number): MapStyle[] {
    let partitionValues: string[] = [];
    for (let p of this.partionColumNames) {
      let v = feature.get(p);
      if (v) v = v.toString();
      partitionValues.push(v ?? null);
    }
    if (partitionValues.length === 0) {
      partitionValues.push(null);
    }
    const key: string = JSON.stringify(partitionValues);
    let styles = this.stylesCache[key] as MapStyle[];
    if (!styles) {
      styles = MapVectorStyle.findStylesCore(this.stylesData, partitionValues);
      if (styles.length === 0 && partitionValues.find((_) => _)) {
        for (let i = 0; i < partitionValues.length; i++) {
          partitionValues[i] = null;
        }
        styles = MapVectorStyle.findStylesCore(this.stylesData, partitionValues);
      }
      this.stylesCache[key] = styles;
    }

    return styles;
  }

  private static findStylesCore(styles: MapStyle[], values: string[]): MapStyle[] {
    let matchCount = -1;
    let results: MapStyle[] = [];
    let i = 0;
    for (const s of styles) {
      s.zIndex = ++i;
      let partitions: string[][];
      if (!s.partition || typeof s.partition === 'string' || typeof s.partition === 'number') {
        partitions = [[s.partition as string]];
      } else {
        partitions = s.partition as string[][];
      }
      if (partitions) {
        for (let i = 0; i < partitions.length; i++) {
          let arr = partitions[i];
          let isMatch = true;
          for (let j = 0; j < arr.length; j++) {
            if (!values.includes(arr[j] ?? null)) {
              isMatch = false;
              break;
            }
          }
          if (isMatch && arr.length >= matchCount) {
            if (arr.length > matchCount) {
              results = [];
            }
            results.push(s);
            matchCount = arr.length;
          }
        }
      }
    }
    return results;
  }
}
